import { Text } from "@zapier/design-system";
import styles from "./Sidebar.module.css";
import { buildNavigationRoute, ServiceRoute } from "src/utils/routes";
import { HomepageMenuItem, SidebarMenu } from "./Components/SidebarMenu";
import { Category, NavigationLink } from "src/server/zsl/templates/types";
import { usePathname } from "next/navigation";

interface SidebarProps {
  categories: Category[];
  productsMenu?: ServiceRoute[];
  includeHomepage?: boolean;
  className?: string;
  isCustomPage: boolean;
  navigationApps: NavigationLink[];
}

/**
 * Users should see the top-most accordion in the menu as default open.
 * Ex: when there is a products, it's the open one. When there is an apps section, the categories one is the top one.
 */
export const Sidebar = ({
  categories,
  productsMenu,
  includeHomepage = false,
  className,
  isCustomPage,
  navigationApps,
  ...rest
}: SidebarProps) => {
  const pathname = usePathname();

  const categoriesMenu = categories.map((category) =>
    buildNavigationRoute(
      category,
      pathname,
      isCustomPage ? "category" : undefined,
    ),
  );

  const navigationAppsMenu = navigationApps.map((app) =>
    buildNavigationRoute(app, pathname, "app"),
  );

  return (
    <div className={className} {...rest}>
      {includeHomepage ? (
        <HomepageMenuItem />
      ) : (
        <div className={styles.header}>
          <Text type="Body4">Browse by:</Text>
        </div>
      )}
      {productsMenu && productsMenu.length > 0 && (
        <SidebarMenu menu={productsMenu} defaultOpen title="Products" />
      )}
      <SidebarMenu
        menu={categoriesMenu}
        defaultOpen={isCustomPage}
        title="Use Case"
      />
      {navigationApps && navigationApps.length > 0 && (
        <SidebarMenu menu={navigationAppsMenu} title="Apps" />
      )}
    </div>
  );
};
